import { getJourneyStudioUrl } from 'utils/appRoutes';
import { useGetJourneyResourceData } from '../hooks/useGetJourneyResourceData';
import { ActivityItem as ActivityItemType } from '../Launchpad.types';
import { ActivityItem } from './ActivityItem';

export const JourneyItem = (props: {
  item: ActivityItemType;
  titleWidth: number;
}) => {
  const {
    resource: journey,
    isLoading,
    hasError,
  } = useGetJourneyResourceData(props.item.resourceId);

  if (!journey) return <></>;

  // Resource url
  const url = getJourneyStudioUrl(journey.id, journey.workflowType);

  return (
    <ActivityItem
      {...props}
      isHidden={!journey || journey.isArchived}
      isLoading={isLoading}
      hasError={hasError}
      resource={journey}
      url={url}
    />
  );
};
